// Per-product upload button text for the Upload Lift (CloudLift) widgets.
//
// The app's saved fields use one generic label per type ("Upload Image",
// "Upload Photo", ...), which is wrong for listings that ask for something
// more specific (handprint/footprint, paw/nose print, a locket's cover
// handwriting and inside photo). product-customizer.liquid publishes the
// wanted text as window.anthologyUploadText = { fingerprint: '...', photo:
// '...' } (keyed by the #uploadlift-<type> container), and this patches the
// app config the storefront loads.
//
// Timing: the app config (Cloudlift.upload.config) is assigned by the app's
// own deferred upload.js, and the widget UI is built later by app-upload.js,
// which loads asynchronously after that. Rather than racing to hook the
// assignment (anthology-sticky-bar.js installs its own hook for the soundwave
// text, and two hooks on the same property overwrite each other), wait for
// the config to exist and patch it in place. Only this theme is affected; the
// app's saved settings are untouched.
(function () {
  var TEXT = window.anthologyUploadText;
  if (!TEXT) return;

  function patch(cfg) {
    cfg.fields.forEach(function (f) {
      var m = /^#uploadlift-([a-z]+)(?:-back)?$/.exec(f.selector || '');
      if (m && TEXT[m[1]]) f.text = TEXT[m[1]];
    });
  }

  var tries = 0;
  (function wait() {
    var C = window.Cloudlift;
    var cfg = C && C.upload && C.upload.config;
    if (cfg && cfg.fields) {
      patch(cfg);
      return;
    }
    if (++tries < 400) setTimeout(wait, 25);
  })();
})();
